/** Account-level user types (not per-deal transaction team roles). */

export const USER_TYPES = [
    { value: 'real_estate_agent', label: 'Real Estate Agent' },
    { value: 'managing_broker', label: 'Managing Broker' },
    { value: 'transaction_coordinator', label: 'Transaction Coordinator' },
    { value: 'mortgage_broker', label: 'Mortgage Broker' },
    { value: 'lender', label: 'Lender' },
    { value: 'title_officer', label: 'Title Officer' },
    { value: 'escrow_officer', label: 'Escrow Officer' },
    { value: 'real_estate_attorney', label: 'Real Estate Attorney' },
    { value: 'inspector', label: 'Inspector' },
    { value: 'appraiser', label: 'Appraiser' },
    { value: 'insurance_broker', label: 'Insurance Broker' },
    { value: 'surveyor', label: 'Surveyor' },
    { value: 'buyer', label: 'Buyer' },
    { value: 'seller', label: 'Seller' },
    { value: 'buyer_seller', label: 'Buyer / Seller' },
];

const USER_TYPE_LABELS = Object.fromEntries(
    USER_TYPES.map(({ value, label }) => [value, label]),
);

/** Side-specific roles stored as user_type → canonical account type. */
const LEGACY_USER_TYPE_ALIASES = {
    buyers_transaction_coordinator: 'transaction_coordinator',
    sellers_transaction_coordinator: 'transaction_coordinator',
    transaction_coordinator: 'transaction_coordinator',
    buyers_agent: 'real_estate_agent',
    sellers_agent: 'real_estate_agent',
    buyer_agent: 'real_estate_agent',
    seller_agent: 'real_estate_agent',
    "buyer's_agent": 'real_estate_agent',
    "seller's_agent": 'real_estate_agent',
};

export function normalizeUserType(value) {
    if (!value) return value;
    const key = String(value).trim().toLowerCase().replace(/\s+/g, '_');
    if (LEGACY_USER_TYPE_ALIASES[key]) {
        return LEGACY_USER_TYPE_ALIASES[key];
    }
    if (USER_TYPE_LABELS[key]) {
        return key;
    }
    return String(value).trim();
}

export function formatUserTypeLabel(value) {
    const normalized = normalizeUserType(value);
    if (!normalized) return '—';
    return USER_TYPE_LABELS[normalized] || normalized.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function isRealEstateAgentUserType(value) {
    const normalized = normalizeUserType(value);
    return normalized === 'real_estate_agent' || normalized === 'managing_broker';
}
